import Divider from '@material-ui/core/Divider';
import React from 'react';

const HorizontalBoxDivider: React.FunctionComponent = () => {
  return <Divider />;
};

export { HorizontalBoxDivider };
